// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2017 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

.neuroglancer-position-dimension-plot {
  display: grid;
  overflow: hidden;
  position: relative;
}

.neuroglancer-position-dimension-plot[data-orientation="column"] {
  grid-template-areas: "labels . graph";
  grid-template-rows: 1fr;
  grid-template-columns: 0fr 3px 0fr;
}

.neuroglancer-position-dimension-plot[data-orientation="row"] {
  grid-template-areas:
    "labels"
    "."
    "graph";
  grid-template-columns: minmax(0px, 1fr);
  grid-template-rows: 0fr 3px 0fr;
}

.neuroglancer-position-dimension-plot-lowerbound,
.neuroglancer-position-dimension-plot-upperbound,
.neuroglancer-position-dimension-plot-hoverposition {
  grid-area: labels;
  font-family: monospace;
  font-size: medium;
  user-select: none;
}

.neuroglancer-position-dimension-plot[data-orientation="column"]
  :is(
    .neuroglancer-position-dimension-plot-lowerbound,
    .neuroglancer-position-dimension-plot-upperbound,
    .neuroglancer-position-dimension-plot-hoverposition
  ) {
  text-align: right;
}

.neuroglancer-position-dimension-plot[data-orientation="row"]
  :is(
    .neuroglancer-position-dimension-plot-lowerbound,
    .neuroglancer-position-dimension-plot-upperbound,
    .neuroglancer-position-dimension-plot-hoverposition
  ) {
  max-width: max-content;
}

.neuroglancer-position-dimension-plot > canvas {
  grid-area: graph;
}

.neuroglancer-position-dimension-plot[data-orientation="column"] > canvas {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
`, "",{"version":3,"sources":["webpack://./../../../../nmcp-neuroglancer/dist/package/lib/widget/position_plot.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE;;;WAGS;EACT,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;;;EAGE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":["/**\n * @license\n * Copyright 2017 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n.neuroglancer-position-dimension-plot {\n  display: grid;\n  overflow: hidden;\n  position: relative;\n}\n\n.neuroglancer-position-dimension-plot[data-orientation=\"column\"] {\n  grid-template-areas: \"labels . graph\";\n  grid-template-rows: 1fr;\n  grid-template-columns: 0fr 3px 0fr;\n}\n\n.neuroglancer-position-dimension-plot[data-orientation=\"row\"] {\n  grid-template-areas:\n    \"labels\"\n    \".\"\n    \"graph\";\n  grid-template-columns: minmax(0px, 1fr);\n  grid-template-rows: 0fr 3px 0fr;\n}\n\n.neuroglancer-position-dimension-plot-lowerbound,\n.neuroglancer-position-dimension-plot-upperbound,\n.neuroglancer-position-dimension-plot-hoverposition {\n  grid-area: labels;\n  font-family: monospace;\n  font-size: medium;\n  user-select: none;\n}\n\n.neuroglancer-position-dimension-plot[data-orientation=\"column\"]\n  :is(\n    .neuroglancer-position-dimension-plot-lowerbound,\n    .neuroglancer-position-dimension-plot-upperbound,\n    .neuroglancer-position-dimension-plot-hoverposition\n  ) {\n  text-align: right;\n}\n\n.neuroglancer-position-dimension-plot[data-orientation=\"row\"]\n  :is(\n    .neuroglancer-position-dimension-plot-lowerbound,\n    .neuroglancer-position-dimension-plot-upperbound,\n    .neuroglancer-position-dimension-plot-hoverposition\n  ) {\n  max-width: max-content;\n}\n\n.neuroglancer-position-dimension-plot > canvas {\n  grid-area: graph;\n}\n\n.neuroglancer-position-dimension-plot[data-orientation=\"column\"] > canvas {\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
